import React from 'react';
import { Card, Input, Space, Button, message } from 'antd';
import { keccak256 } from 'js-sha3';

const AddressConvert: React.FC = () => {
  const [address, setAddress] = React.useState('');
  const [result, setResult] = React.useState('');

  // 转换为checksum格式地址
  const toChecksum = (address: string): string => {
    const addr = address.toLowerCase().replace('0x', '');
    if (!/^[0-9a-f]{40}$/.test(addr)) {
      throw new Error('无效的以太坊地址格式');
    }

    // 使用keccak256计算checksum
    const hash = keccak256(addr);
    let result = '0x';
    
    for (let i = 0; i < addr.length; i++) {
      if (parseInt(hash[i], 16) >= 8) {
        result += addr[i].toUpperCase();
      } else {
        result += addr[i];
      }
    }
    
    return result;
  };

  const handleConvert = () => {
    const trimmed = address.trim();
    if (!trimmed) {
      message.error('请输入地址');
      return;
    }

    try {
      const checksumAddr = toChecksum(trimmed);
      setResult(checksumAddr);
      message.success('转换成功');
    } catch (error) {
      message.error('地址格式错误');
      setResult('');
    }
  };

  const copyToClipboard = () => {
    if (result) {
      navigator.clipboard.writeText(result);
      message.success('已复制到剪贴板');
    }
  };

  return (
    <Card title="地址转换" className="tool-container-responsive">
      <Space direction="vertical" style={{ width: '100%' }}>
        <Input
          placeholder="输入以太坊地址"
          value={address}
          onChange={e => setAddress(e.target.value)}
          onPressEnter={handleConvert}
        />
        <div style={{ textAlign: 'center' }}>
          <Button type="primary" onClick={handleConvert}>
            转换为Checksum格式
          </Button>
        </div>
        <Input
          placeholder="Checksum格式地址"
          value={result}
          readOnly
          addonAfter={
            <Button 
              type="text" 
              size="small" 
              onClick={copyToClipboard}
              disabled={!result}
            >
              复制
            </Button>
          }
        />
        <div style={{ 
          padding: 12, 
          background: '#f5f5f5', 
          borderRadius: 6, 
          fontSize: 12, 
          color: '#666' 
        }}>
          <div style={{ fontWeight: 500, marginBottom: 4 }}>说明：</div>
          <div>• Checksum格式可以防止地址输入错误</div>
          <div>• 支持输入大小写混合的地址进行转换</div>
          <div>• 转换后的地址在大多数钱包中都能正确识别</div>
        </div>
      </Space>
    </Card>
  );
};

export default AddressConvert; 